import React from "react";
import { Icon } from "@chakra-ui/react";

export function StepTwoMobileSvg() {
  return (
    <Icon width="100%" height="auto" fill="none" viewBox="0 0 430 400">
      <g clipPath="url(#step-2-mobile-svg__a)">
        <circle cx="308.687" cy="218.105" r="253.766" stroke="#765BF0" strokeWidth=".678" />
        <circle cx="308.687" cy="243.493" r="186.005" stroke="#421BB0" strokeWidth=".678" />
        <circle cx="342.568" cy="243.493" r="219.885" stroke="#765BF0" strokeWidth=".678" />
        <circle cx="308.687" cy="243.493" r="186.005" stroke="#765BF0" strokeWidth=".678" />
        <circle cx="310.716" cy="243.493" r="169.403" fill="#421BB0" />
        <g filter="url(#step-2-mobile-svg__b)">
          <circle cx="209.078" cy="226.552" r="10.164" fill="#765BF0" transform="rotate(90 209.078 226.552)" />
        </g>
        <g filter="url(#step-2-mobile-svg__c)">
          <circle cx="209.078" cy="192.672" r="10.164" fill="#C6BFF1" transform="rotate(90 209.078 192.672)" />
        </g>
        <path
          fill="#fff"
          d="M209.074 190.865a1.807 1.807 0 1 0 0 3.614 1.807 1.807 0 0 0 0-3.614Zm0 33.881a1.807 1.807 0 1 0 0 3.614 1.807 1.807 0 0 0 0-3.614Zm0-32.074h-.339v33.881h.678v-33.881h-.339Z"
        />
        <g filter="url(#step-2-mobile-svg__d)">
          <circle cx="412.359" cy="192.672" r="10.164" fill="#765BF0" transform="rotate(-90 412.359 192.672)" />
        </g>
        <g filter="url(#step-2-mobile-svg__e)">
          <circle cx="412.359" cy="226.553" r="10.164" fill="#C6BFF1" transform="rotate(-90 412.359 226.553)" />
        </g>
        <g filter="url(#step-2-mobile-svg__f)">
          <circle cx="412.359" cy="158.792" r="10.164" fill="#C6BFF1" transform="rotate(-90 412.359 158.792)" />
        </g>
        <g filter="url(#step-2-mobile-svg__g)">
          <circle cx="412.359" cy="328.195" r="10.164" fill="#765BF0" transform="rotate(-90 412.359 328.195)" />
        </g>
        <path
          fill="#fff"
          d="M412.359 228.36a1.807 1.807 0 1 0 0-3.614 1.807 1.807 0 0 0 0 3.614Zm0-33.881a1.807 1.807 0 1 0 0-3.614 1.807 1.807 0 0 0 0 3.614Zm0 32.074h.339v-33.881h-.677v33.881h.338Z"
        />
        <g filter="url(#step-2-mobile-svg__h)">
          <circle cx="209.078" cy="294.314" r="10.164" fill="#765BF0" transform="rotate(90 209.078 294.314)" />
        </g>
        <g filter="url(#step-2-mobile-svg__i)">
          <circle cx="209.078" cy="260.433" r="10.164" fill="#C6BFF1" transform="rotate(90 209.078 260.433)" />
        </g>
        <g filter="url(#step-2-mobile-svg__j)">
          <circle cx="209.078" cy="158.791" r="10.164" fill="#765BF0" transform="rotate(90 209.078 158.791)" />
        </g>
        <g filter="url(#step-2-mobile-svg__k)">
          <circle cx="209.078" cy="328.194" r="10.164" fill="#C6BFF1" transform="rotate(90 209.078 328.194)" />
        </g>
        <path
          fill="#fff"
          d="M209.074 292.507a1.807 1.807 0 1 0 0 3.614 1.807 1.807 0 0 0 0-3.614Zm0 33.881a1.807 1.807 0 1 0 0 3.614 1.807 1.807 0 0 0 0-3.614Zm0-32.074h-.339v33.881h.678v-33.881h-.339Z"
        />
        <g filter="url(#step-2-mobile-svg__l)">
          <circle cx="412.359" cy="260.433" r="10.164" fill="#765BF0" transform="rotate(-90 412.359 260.433)" />
        </g>
        <g filter="url(#step-2-mobile-svg__m)">
          <circle cx="412.359" cy="294.314" r="10.164" fill="#C6BFF1" transform="rotate(-90 412.359 294.314)" />
        </g>
        <path
          fill="#fff"
          d="M412.359 330.001a1.807 1.807 0 1 0 0-3.614 1.807 1.807 0 0 0 0 3.614Zm0-33.88a1.807 1.807 0 1 0 0-3.614 1.807 1.807 0 0 0 0 3.614Zm0 32.073h.339v-33.88h-.677v33.88h.338Z"
        />
        <g filter="url(#step-2-mobile-svg__n)">
          <path
            fill="#12043E"
            d="M28 85.61a2.71 2.71 0 0 1 2.71-2.711h95.544a2.71 2.71 0 0 1 2.71 2.71v14.908a2.71 2.71 0 0 1-2.71 2.71H30.71a2.71 2.71 0 0 1-2.71-2.71V85.609Z"
          />
          <path
            stroke="#765BF0"
            strokeWidth=".678"
            d="M30.71 83.237h95.544a2.372 2.372 0 0 1 2.372 2.373v14.907a2.371 2.371 0 0 1-2.372 2.371H30.711a2.371 2.371 0 0 1-2.372-2.371V85.61a2.372 2.372 0 0 1 2.372-2.373Z"
          />
        </g>
        <path
          fill="#9280F4"
          d="M38.932 96.457c-1.404 0-2.504-.787-2.665-1.95l.85-.304c.09.885.85 1.485 1.824 1.485.86 0 1.467-.465 1.467-1.145 0-.6-.42-.904-1.09-1.056l-1.038-.223c-1.127-.242-1.718-.868-1.718-1.78 0-1.082.94-1.825 2.299-1.825 1.297 0 2.254.671 2.424 1.673l-.85.313c-.063-.725-.715-1.216-1.601-1.216-.787 0-1.342.402-1.342.983 0 .52.385.832.957.957l1.163.269c1.047.232 1.709.787 1.709 1.806 0 1.181-.957 2.013-2.389 2.013Zm4.963 0c-1.082 0-1.762-.581-1.762-1.494 0-.903.626-1.44 1.887-1.628l1.753-.259v-.206c0-.733-.465-1.154-1.27-1.154-.787 0-1.315.412-1.458 1.119l-.805-.305c.295-.984 1.127-1.52 2.29-1.52 1.28 0 2.04.662 2.04 1.798v2.191c0 .51.026.957.107 1.288h-.84a7.992 7.992 0 0 1-.073-.903c-.384.706-1.02 1.073-1.869 1.073Zm.152-.68c1.01 0 1.726-.715 1.726-1.726v-.34l-1.619.25c-.814.126-1.207.43-1.207.958 0 .536.42.858 1.1.858Zm5.602.68c-.787 0-1.225-.519-1.225-1.404V91.86h-.859v-.68h.859v-.93l.805-.626v1.556h1.082v.68h-1.082V95c0 .5.179.75.545.75a.712.712 0 0 0 .573-.277l.16.671c-.17.197-.482.313-.858.313Zm1.831-5.277h.805v3.175c0 .894.465 1.386 1.226 1.386 1.073 0 1.735-.966 1.735-2.271v-2.29h.805v5.107h-.805v-.993c-.42.725-1.11 1.163-1.95 1.163-1.091 0-1.816-.751-1.816-1.851V91.18Zm6.843 5.107h-.805V91.18h.805v.966c.322-.689.877-1.136 1.52-1.136.198 0 .368.036.529.125v.859h-.018a1.168 1.168 0 0 0-.617-.17c-.841 0-1.414.867-1.414 2.147v2.316Zm4.949.17c-1.369 0-2.335-1.1-2.335-2.72 0-1.6 1.01-2.727 2.352-2.727.805 0 1.494.402 1.87 1.082v-2.674h.805v6.87h-.805v-.976c-.367.725-1.065 1.145-1.887 1.145Zm.187-.715c.975 0 1.7-.815 1.7-2.004 0-1.225-.734-2.022-1.709-2.022-.983 0-1.69.806-1.69 2.013 0 1.207.707 2.013 1.7 2.013Zm5.399.715c-1.083 0-1.763-.581-1.763-1.494 0-.903.627-1.44 1.888-1.628l1.753-.259v-.206c0-.733-.465-1.154-1.27-1.154-.787 0-1.315.412-1.458 1.119l-.805-.305c.295-.984 1.127-1.52 2.29-1.52 1.279 0 2.039.662 2.039 1.798v2.191c0 .51.027.957.107 1.288h-.84a7.996 7.996 0 0 1-.072-.903c-.385.706-1.02 1.073-1.87 1.073Zm.152-.68c1.01 0 1.726-.715 1.726-1.726v-.34l-1.619.25c-.814.126-1.208.43-1.208.958 0 .536.42.858 1.1.858Zm4.602 2.585c-.501 0-.903-.223-1.154-.527l.412-.627c.17.26.429.448.742.448.34 0 .572-.224.787-.725l.277-.617-2.325-5.134h.912l.662 1.53c.447 1.019.877 2.092 1.118 2.683h.018c.232-.59.626-1.673 1.028-2.684l.609-1.53h.876l-2.424 5.868c-.384.922-.823 1.315-1.538 1.315Zm9.95-4.347h-2.719V93.3h2.72v.715Zm6.004 2.442c-1.404 0-2.504-.787-2.665-1.95l.85-.304c.089.885.85 1.485 1.824 1.485.859 0 1.467-.465 1.467-1.145 0-.6-.42-.904-1.091-1.056l-1.038-.223c-1.127-.242-1.717-.868-1.717-1.78 0-1.082.94-1.825 2.299-1.825 1.297 0 2.254.671 2.424 1.673l-.85.313c-.063-.725-.716-1.216-1.601-1.216-.787 0-1.342.402-1.342.983 0 .52.385.832.957.957l1.163.269c1.047.232 1.709.787 1.709 1.806 0 1.181-.958 2.013-2.389 2.013Zm3.487-5.277h.805v3.175c0 .894.465 1.386 1.225 1.386 1.074 0 1.736-.966 1.736-2.271v-2.29h.805v5.107h-.805v-.993c-.42.725-1.11 1.163-1.95 1.163-1.091 0-1.816-.751-1.816-1.851V91.18Zm6.843 5.107h-.805V91.18h.805v.894c.403-.662 1.083-1.064 1.914-1.064 1.136 0 1.807.76 1.807 1.959v3.318h-.805v-3.166c0-.877-.447-1.396-1.225-1.396-1.002 0-1.69.868-1.69 2.13v2.432Zm7.202.17c-1.368 0-2.334-1.1-2.334-2.72 0-1.6 1.01-2.727 2.352-2.727.805 0 1.494.402 1.87 1.082v-2.674h.805v6.87h-.805v-.976c-.367.725-1.065 1.145-1.888 1.145Zm.188-.715c.975 0 1.7-.815 1.7-2.004 0-1.225-.734-2.022-1.709-2.022-.984 0-1.69.806-1.69 2.013 0 1.207.706 2.013 1.699 2.013Zm5.398.715c-1.082 0-1.762-.581-1.762-1.494 0-.903.626-1.44 1.887-1.628l1.754-.259v-.206c0-.733-.466-1.154-1.271-1.154-.787 0-1.314.412-1.458 1.119l-.805-.305c.296-.984 1.127-1.52 2.29-1.52 1.279 0 2.04.662 2.04 1.798v2.191c0 .51.026.957.107 1.288h-.841a7.766 7.766 0 0 1-.071-.903c-.385.706-1.02 1.073-1.87 1.073Zm.152-.68c1.011 0 1.727-.715 1.727-1.726v-.34l-1.619.25c-.814.126-1.208.43-1.208.958 0 .536.42.858 1.1.858Zm4.602 2.585c-.5 0-.903-.223-1.153-.527l.411-.627c.17.26.429.448.742.448.34 0 .573-.224.788-.725l.277-.617-2.326-5.134h.913l.662 1.53c.447 1.019.876 2.092 1.118 2.683h.017c.233-.59.627-1.673 1.029-2.684l.608-1.53h.877l-2.424 5.868c-.385.922-.823 1.315-1.539 1.315Z"
        />
        <path
          fill="#765BF0"
          d="M232.793 286.86a2.71 2.71 0 0 1 2.71-2.71h65.729a2.71 2.71 0 0 1 2.71 2.71v62.341a2.71 2.71 0 0 1-2.71 2.71h-65.729a2.71 2.71 0 0 1-2.71-2.71V286.86Z"
        />
        <rect width="57.597" height="32.525" x="239.566" y="312.609" fill="#fff" rx="1.355" />
        <rect width="18.973" height="18.973" x="239.566" y="290.926" fill="#C6BFF1" rx="1.355" />
        <rect width="35.913" height="18.973" x="261.254" y="290.926" fill="#fff" rx="1.355" />
        <path
          fill="#fff"
          stroke="#fff"
          strokeWidth=".678"
          d="M320.207 284.489h65.728a2.373 2.373 0 0 1 2.372 2.372v62.34a2.373 2.373 0 0 1-2.372 2.372h-65.729a2.372 2.372 0 0 1-2.371-2.372v-62.34a2.372 2.372 0 0 1 2.372-2.372Z"
        />
        <rect width="57.597" height="18.973" x="324.27" y="326.162" fill="#765BF0" rx="1.355" />
        <rect width="57.597" height="32.525" x="324.27" y="290.926" fill="#C6BFF1" rx="1.355" />
        <g filter="url(#step-2-mobile-svg__o)">
          <rect width="60.985" height="33.881" x="232.793" y="135.075" fill="#fff" rx="16.94" />
        </g>
        <circle cx="276.158" cy="152.015" r="12.197" fill="#40DE9E" />
        <g filter="url(#step-2-mobile-svg__p)">
          <rect width="33.881" height="33.881" x="354.766" y="135.075" fill="#C6BFF1" rx="16.94" />
        </g>
        <g filter="url(#step-2-mobile-svg__q)">
          <path
            fill="#765BF0"
            d="M307.328 137.786a2.711 2.711 0 0 1 2.711-2.711h28.459a2.711 2.711 0 0 1 2.711 2.711v28.459a2.711 2.711 0 0 1-2.711 2.711h-28.459a2.711 2.711 0 0 1-2.711-2.711v-28.459Z"
          />
        </g>
        <g filter="url(#step-2-mobile-svg__r)">
          <path
            fill="#fff"
            d="M232.793 185.218a2.71 2.71 0 0 1 2.71-2.71h150.431a2.71 2.71 0 0 1 2.71 2.71v14.908a2.71 2.71 0 0 1-2.71 2.71H235.503a2.71 2.71 0 0 1-2.71-2.71v-14.908Z"
          />
        </g>
        <rect width="85" height="7" x="297" y="189" fill="#40DE9E" rx="1.355" />
        <path
          fill="#101111"
          d="M244.53 196.066c-1.878 0-3.229-1.422-3.229-3.399s1.342-3.399 3.229-3.399c1.879 0 3.22 1.422 3.22 3.399s-1.341 3.399-3.22 3.399Zm0-.796c1.369 0 2.326-1.065 2.326-2.603 0-1.538-.948-2.603-2.326-2.603-1.386 0-2.325 1.065-2.325 2.603 0 1.538.948 2.603 2.325 2.603Zm6.746-3.802h-1.109v4.428h-.805v-4.428h-.778v-.679h.778v-.349c0-.975.492-1.583 1.378-1.583.322 0 .644.107.84.286l-.161.554a.71.71 0 0 0-.536-.223c-.43 0-.761.313-.725 1.136l.009.179h1.109v.679Zm3.504 0h-1.109v4.428h-.805v-4.428h-.778v-.679h.778v-.349c0-.975.492-1.583 1.378-1.583.322 0 .644.107.84.286l-.161.554a.71.71 0 0 0-.536-.223c-.43 0-.761.313-.725 1.136l.009.179h1.109v.679Zm3.321 4.598c-1.53 0-2.567-1.1-2.567-2.728 0-1.646 1.037-2.719 2.558-2.719 1.556 0 2.486 1.127 2.406 2.889h-4.106c-.026 1.118.707 1.869 1.7 1.869.787 0 1.377-.456 1.565-1.216l.725.313c-.34 1.002-1.181 1.592-2.281 1.592Zm-.018-4.767c-.921 0-1.592.626-1.664 1.574h3.229c-.045-.957-.644-1.574-1.565-1.574Zm4.422 4.597h-.805v-5.107h.805v.966c.322-.689.876-1.136 1.52-1.136.197 0 .367.036.528.125v.859h-.018a1.16 1.16 0 0 0-.617-.17c-.841 0-1.413.867-1.413 2.146v2.317Zm6.647 0v-5.188a2.442 2.442 0 0 1-1.35.904v-.805a1.968 1.968 0 0 0 1.467-1.369h.706v6.458h-.823Zm7.142.17c-1.27 0-2.156-.778-2.156-1.852 0-.831.537-1.431 1.369-1.949l-.099-.108c-.518-.563-.724-.966-.724-1.449 0-.832.689-1.44 1.637-1.44.93 0 1.583.582 1.583 1.413 0 .689-.492 1.208-1.261 1.682l1.413 1.503c.152-.501.152-1.11-.018-1.771l.787.322c.152.751.09 1.466-.17 2.075l1.315 1.404h-1.109l-.662-.707a2.442 2.442 0 0 1-1.905.877Zm-.17-4.249.054.054c.554-.358.948-.716.948-1.163 0-.438-.331-.742-.796-.742-.483 0-.823.322-.823.76 0 .331.17.644.617 1.091Zm-1.154 2.317c0 .689.573 1.198 1.369 1.198.563 0 1.037-.259 1.359-.688l-1.708-1.861c-.591.349-1.02.778-1.02 1.351Zm12.757 1.762h-4.696v-.134c0-.957.537-1.762 1.593-2.424l1.019-.635c.832-.528 1.136-.921 1.136-1.485 0-.716-.545-1.19-1.342-1.19-.912 0-1.493.644-1.484 1.601l-.868-.232c.072-1.297.993-2.129 2.361-2.129 1.297 0 2.192.796 2.192 1.941 0 .823-.474 1.485-1.413 2.066l-1.118.689c-.564.34-.886.724-.975 1.199h3.595v.733Z"
        />
        <g filter="url(#step-2-mobile-svg__s)">
          <path
            fill="#fff"
            d="M232.793 219.099a2.71 2.71 0 0 1 2.71-2.711h150.431a2.711 2.711 0 0 1 2.71 2.711v14.907a2.711 2.711 0 0 1-2.71 2.711H235.503a2.71 2.71 0 0 1-2.71-2.711v-14.907Z"
          />
        </g>
        <rect width="56" height="7" x="326" y="223" fill="#40DE9E" rx="1.355" />
        <path
          fill="#101111"
          d="M241.677 229.777v-6.458h1.333l.769 2.111c.394 1.028.912 2.495 1.19 3.256h.009c.277-.761.787-2.236 1.18-3.256l.761-2.111h1.297v6.458h-.868v-2.719c0-.734.009-1.753.045-2.702h-.018c-.125.394-.465 1.342-.689 1.986l-1.315 3.435h-.841l-1.332-3.435c-.251-.715-.573-1.592-.707-1.986h-.009c.036 1.083.045 2.013.045 2.693v2.728h-.85Zm10.411.17c-1.512 0-2.54-1.082-2.54-2.719 0-1.655 1.028-2.728 2.54-2.728 1.502 0 2.522 1.073 2.522 2.728 0 1.637-1.02 2.719-2.522 2.719Zm0-.716c1.002 0 1.699-.796 1.699-2.003 0-1.226-.697-2.022-1.699-2.022-1.02 0-1.718.796-1.718 2.022 0 1.207.698 2.003 1.718 2.003Zm4.518.546h-.805v-5.107h.805v.894c.403-.662 1.082-1.064 1.914-1.064 1.136 0 1.807.76 1.807 1.958v3.319h-.805v-3.166c0-.877-.447-1.396-1.225-1.396-1.002 0-1.691.868-1.691 2.129v2.433Zm7.202.17c-1.369 0-2.335-1.1-2.335-2.719 0-1.601 1.011-2.728 2.353-2.728.805 0 1.494.402 1.869 1.082v-2.675h.805v6.87h-.805v-.975c-.367.724-1.064 1.145-1.887 1.145Zm.188-.716c.975 0 1.699-.814 1.699-2.003 0-1.226-.733-2.022-1.708-2.022-.984 0-1.691.805-1.691 2.013 0 1.207.707 2.012 1.7 2.012Zm5.398.716c-1.082 0-1.762-.582-1.762-1.494 0-.903.626-1.44 1.887-1.628l1.753-.259v-.206c0-.733-.465-1.154-1.27-1.154-.787 0-1.315.412-1.458 1.118l-.805-.304c.295-.984 1.127-1.52 2.29-1.52 1.279 0 2.039.661 2.039 1.797v2.192c0 .51.027.957.108 1.288h-.841a7.957 7.957 0 0 1-.072-.904c-.384.707-1.019 1.074-1.869 1.074Zm.152-.68c1.011 0 1.726-.716 1.726-1.726v-.34l-1.619.25c-.814.126-1.207.43-1.207.957 0 .537.42.859 1.1.859Zm4.602 2.585c-.501 0-.903-.224-1.154-.528l.412-.626c.17.26.429.447.742.447.34 0 .573-.223.787-.724l.278-.617-2.326-5.134h.912l.662 1.529c.447 1.02.877 2.093 1.118 2.683h.018c.233-.59.626-1.672 1.029-2.683l.608-1.529h.877l-2.424 5.867c-.385.921-.823 1.315-1.539 1.315Zm9.951-4.347h-2.719v-.716h2.719v.716Zm4.823 2.272h-.868v-6.458h4.312v.778h-3.444v2.075h2.889v.752h-2.889v2.853Zm5.316 0h-.805v-5.107h.805v.966c.322-.689.877-1.136 1.521-1.136.197 0 .367.035.528.125v.858h-.018a1.172 1.172 0 0 0-.618-.169c-.84 0-1.413.867-1.413 2.146v2.317Zm3.88-5.787h-.805v-1.279h.805v1.279Zm0 5.787h-.805v-5.107h.805v5.107Zm3.516.17c-1.369 0-2.335-1.1-2.335-2.719 0-1.601 1.011-2.728 2.353-2.728.805 0 1.493.402 1.869 1.082v-2.675h.805v6.87h-.805v-.975c-.367.724-1.064 1.145-1.887 1.145Zm.187-.716c.975 0 1.7-.814 1.7-2.003 0-1.226-.733-2.022-1.708-2.022-.984 0-1.691.805-1.691 2.013 0 1.207.707 2.012 1.699 2.012Zm5.399.716c-1.083 0-1.762-.582-1.762-1.494 0-.903.626-1.44 1.887-1.628l1.753-.259v-.206c0-.733-.465-1.154-1.27-1.154-.787 0-1.315.412-1.458 1.118l-.805-.304c.295-.984 1.127-1.52 2.29-1.52 1.279 0 2.039.661 2.039 1.797v2.192c0 .51.027.957.107 1.288h-.84a7.957 7.957 0 0 1-.072-.904c-.385.707-1.02 1.074-1.869 1.074Zm.152-.68c1.01 0 1.726-.716 1.726-1.726v-.34l-1.619.25c-.814.126-1.207.43-1.207.957 0 .537.42.859 1.1.859Zm4.602 2.585c-.501 0-.903-.224-1.154-.528l.412-.626c.169.26.429.447.742.447.34 0 .572-.223.787-.724l.277-.617-2.325-5.134h.912l.662 1.529c.447 1.02.877 2.093 1.118 2.683h.018c.232-.59.626-1.672 1.029-2.683l.608-1.529h.876l-2.424 5.867c-.384.921-.823 1.315-1.538 1.315Z"
        />
        <g filter="url(#step-2-mobile-svg__t)">
          <path
            fill="#fff"
            d="M232.793 252.979a2.71 2.71 0 0 1 2.71-2.71h150.431a2.71 2.71 0 0 1 2.71 2.71v14.908a2.71 2.71 0 0 1-2.71 2.71H235.503a2.71 2.71 0 0 1-2.71-2.71v-14.908Z"
          />
        </g>
        <rect width="64" height="7" x="318" y="257" fill="#40DE9E" rx="1.355" />
        <path
          fill="#101111"
          d="M245.926 263.657h-4.696v-.134c0-.957.537-1.762 1.592-2.424l1.02-.635c.832-.528 1.136-.921 1.136-1.485 0-.715-.546-1.189-1.342-1.189-.912 0-1.494.644-1.485 1.601l-.867-.233c.071-1.297.992-2.129 2.361-2.129 1.297 0 2.191.796 2.191 1.941 0 .823-.474 1.485-1.413 2.066l-1.118.689c-.563.34-.885.725-.975 1.199h3.596v.733Zm1.566 0h-.921l2.048-2.629-1.923-2.478h.948l1.458 1.869 1.449-1.869h.922l-1.915 2.451 2.067 2.656h-.957l-1.593-2.039-1.583 2.039Zm7.685 0v-6.458h1.332l.77 2.111c.393 1.029.912 2.496 1.189 3.256h.009c.277-.76.787-2.236 1.181-3.256l.76-2.111h1.297v6.458h-.868v-2.719c0-.733.009-1.753.045-2.701h-.018c-.125.393-.465 1.342-.688 1.986l-1.315 3.434h-.841l-1.333-3.434c-.25-.716-.572-1.593-.706-1.986h-.009a83.94 83.94 0 0 1 .044 2.692v2.728h-.849Zm9.587.17c-1.082 0-1.762-.581-1.762-1.494 0-.903.626-1.44 1.888-1.627l1.753-.26v-.206c0-.733-.465-1.153-1.27-1.153-.787 0-1.315.411-1.458 1.118l-.805-.304c.295-.984 1.127-1.521 2.289-1.521 1.28 0 2.04.662 2.04 1.798v2.191c0 .51.027.957.107 1.288h-.841a8.23 8.23 0 0 1-.071-.903c-.385.706-1.02 1.073-1.87 1.073Zm.152-.68c1.011 0 1.727-.715 1.727-1.726v-.34l-1.619.251c-.814.125-1.208.429-1.208.957 0 .536.421.858 1.1.858Zm4.305.51h-.921l2.048-2.629-1.923-2.478h.948l1.458 1.869 1.449-1.869h.922l-1.914 2.451 2.066 2.656h-.957l-1.592-2.039-1.584 2.039Zm7.81 0h-.876l3.112-6.458h.877l-3.113 6.458Zm7.714 0-1.717-6.458h.957l.563 2.299c.358 1.351.609 2.37.814 3.113h.018c.17-.662.492-1.995.796-3.122l.609-2.29h.876l.608 2.29c.313 1.136.671 2.478.841 3.113h.018c.179-.626.465-1.834.769-3.095l.546-2.308h.93l-1.646 6.458h-1.171l-.644-2.46c-.251-.966-.546-2.155-.707-2.826h-.018c-.143.671-.456 1.905-.689 2.826l-.617 2.46h-1.136Zm9.816.17c-1.529 0-2.567-1.1-2.567-2.728 0-1.646 1.038-2.719 2.558-2.719 1.556 0 2.487 1.127 2.406 2.889h-4.105c-.027 1.118.706 1.869 1.699 1.869.787 0 1.378-.456 1.565-1.216l.725.313c-.34 1.002-1.181 1.592-2.281 1.592Zm-.018-4.767c-.921 0-1.592.626-1.663 1.574h3.228c-.044-.957-.644-1.574-1.565-1.574Zm5.898 4.767c-1.529 0-2.567-1.1-2.567-2.728 0-1.646 1.038-2.719 2.558-2.719 1.556 0 2.487 1.127 2.406 2.889h-4.105c-.027 1.118.706 1.869 1.699 1.869.787 0 1.378-.456 1.565-1.216l.725.313c-.34 1.002-1.181 1.592-2.281 1.592Zm-.018-4.767c-.921 0-1.592.626-1.664 1.574h3.229c-.044-.957-.644-1.574-1.565-1.574Zm4.422 4.597h-.805v-6.869h.805v4.365l2.442-2.603h.939l-1.816 1.968 2.12 3.139h-.993l-1.672-2.549-1.02 1.1v1.449Z"
        />
        <path fill="url(#step-2-mobile-svg__u)" d="M430 0h189v430H430z" transform="rotate(90 430 0)" />
        <path fill="url(#step-2-mobile-svg__v)" d="M0 400h103v430H0z" transform="rotate(-90 0 400)" />
        <path fill="url(#step-2-mobile-svg__w)" d="M0 0h116v443H0z" />
      </g>
      <defs>
        <filter
          id="step-2-mobile-svg__b"
          width="48.282"
          height="60.512"
          x="184.937"
          y="213.768"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__c"
          width="48.282"
          height="60.512"
          x="184.937"
          y="179.887"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__d"
          width="48.282"
          height="60.512"
          x="388.219"
          y="179.887"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__e"
          width="48.282"
          height="60.512"
          x="388.219"
          y="213.768"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__f"
          width="48.282"
          height="60.512"
          x="388.219"
          y="146.007"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__g"
          width="48.282"
          height="60.512"
          x="388.219"
          y="315.41"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__h"
          width="48.282"
          height="60.512"
          x="184.937"
          y="281.529"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__i"
          width="48.282"
          height="60.512"
          x="184.937"
          y="247.648"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__j"
          width="48.282"
          height="60.512"
          x="184.937"
          y="146.006"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__k"
          width="48.282"
          height="60.512"
          x="184.937"
          y="315.41"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__l"
          width="48.282"
          height="60.512"
          x="388.219"
          y="247.648"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__m"
          width="48.282"
          height="60.512"
          x="388.219"
          y="281.529"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__n"
          width="128.918"
          height="60.512"
          x="14.023"
          y="80.278"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__o"
          width="88.938"
          height="74.064"
          x="218.816"
          y="132.455"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__p"
          width="61.833"
          height="74.064"
          x="340.789"
          y="132.455"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__q"
          width="61.833"
          height="74.064"
          x="293.351"
          y="132.455"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__r"
          width="183.805"
          height="60.512"
          x="218.816"
          y="179.887"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__s"
          width="183.805"
          height="60.512"
          x="218.816"
          y="213.768"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <filter
          id="step-2-mobile-svg__t"
          width="183.805"
          height="60.512"
          x="218.816"
          y="247.648"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2.621" />
          <feGaussianBlur stdDeviation="2.621" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="10.483" />
          <feGaussianBlur stdDeviation="5.241" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="effect1_dropShadow_12789_13702" result="effect2_dropShadow_12789_13702" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="23.586" />
          <feGaussianBlur stdDeviation="6.988" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend in2="effect2_dropShadow_12789_13702" result="effect3_dropShadow_12789_13702" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_12789_13702" result="shape" />
        </filter>
        <linearGradient id="step-2-mobile-svg__u" x1="430" x2="619" y1="215" y2="215" gradientUnits="userSpaceOnUse">
          <stop stopColor="#12043E" />
          <stop offset="1" stopColor="#12043E" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="step-2-mobile-svg__v" x1="0" x2="103" y1="615" y2="615" gradientUnits="userSpaceOnUse">
          <stop stopColor="#12043E" />
          <stop offset="1" stopColor="#12043E" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="step-2-mobile-svg__w" x1="0" x2="116" y1="221.5" y2="221.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#12043E" />
          <stop offset="1" stopColor="#12043E" stopOpacity="0" />
        </linearGradient>
        <clipPath id="step-2-mobile-svg__a">
          <path fill="#fff" d="M0 0h430v400H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
